/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../error/error-name';

// TODO #53 Ovládání zvuku pro web adaptér.
// - Adapter#fooVolume(volume) => volume
//   - Synchronní metoda pro výpočet hlasitosti slajdu.
//   - Na vstupu hlasitost ze server API.
//   - Vrací hlasitost k započítání do výpočtu celkové hlasitosti.
//   - Pro webOS bude vracet vždy 1.
//   - Pro web bude vracet volume ze vstupu.
// - DeviceStateful#fooVolume(volume) => volume
//   - Shodná funkcionalita, jen volá pro aktuální adaptér.
//   - Fasáda pro přístup z Player aplikace.
// - Slide#fooVolume(volume) => volume
//   - Náhrada za aktuální getter Slide#volume.
//   - Na vstupu master volume zařízení (výsledek DeviceStateful#fooVolume).
//   - Vrací se hlasitost na kterou nastavit <video> element.
//   - Výpočet s uvažování hlavní hlasitosti zařízení je v tomto modulu dočasně deaktivovaný.
// - Player modul
//   - do komponent s nastavením hlasitosti: ViewerVideo, ViewerAudio...
//   - Nastavení hlasitosti <video> elementu s využitím DeviceStateful#fooVolume a Slide#fooVolume.
// - Domyslet lepší názvy než fooVolume.
/**
 * Správce zvuku pro standardní webové technologie.
 * @implements {SoundManager}
 */
class WebSoundManager {
  /** @inheritdoc */
  getVolume() {
    return new Promise(() => {
      const error = new Error('Unable to get the volume.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  isMuted() {
    return new Promise(() => {
      const error = new Error('Unable to get the muted state.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }

  /** @inheritdoc */
  setVolume(volume) {
    return Promise.resolve();
  }
}

export default WebSoundManager;
